<template src="./templates/chevron.html"></template>

<script>
	export default {
		name: 'Chevron'
	};
</script>
